import { ImageUploadField } from '@/components/ui/image-upload-field'
import {
  ORGANISATION_LOGO_ACCEPT,
  ORGANISATION_LOGO_HELPER_TEXT,
  ORGANISATION_LOGO_MAX_BYTES,
  ORGANISATION_LOGO_TYPE_ERROR,
  validateOrganisationLogoFile,
} from '@/lib/organisation-logo-media'

export type OrganisationLogoUploadFieldProps = {
  logoUrl?: string | null
  logoFieldKey?: string
  uploadLogo?: (file: File) => Promise<unknown>
  deleteLogo?: () => Promise<unknown>
  isUploadingLogo?: boolean
  isDeletingLogo?: boolean
  disabled?: boolean
  persistenceNote?: string | null
}

/** Shared organisation logo upload wiring (settings + onboarding wizard). */
export function OrganisationLogoUploadField({
  logoUrl,
  logoFieldKey,
  uploadLogo,
  deleteLogo,
  isUploadingLogo,
  isDeletingLogo,
  disabled,
  persistenceNote,
}: OrganisationLogoUploadFieldProps) {
  return (
    <ImageUploadField
      key={logoFieldKey}
      variant="logo"
      serverImageUrl={logoUrl ?? null}
      uploadLogo={uploadLogo}
      deleteLogo={deleteLogo}
      isUploadingLogo={isUploadingLogo}
      isDeletingLogo={isDeletingLogo}
      disabled={disabled}
      accept={ORGANISATION_LOGO_ACCEPT}
      maxSize={ORGANISATION_LOGO_MAX_BYTES}
      validateFile={validateOrganisationLogoFile}
      fileTypeErrorMessage={ORGANISATION_LOGO_TYPE_ERROR}
      persistenceNote={
        persistenceNote === undefined ? ORGANISATION_LOGO_HELPER_TEXT : persistenceNote
      }
    />
  )
}
